import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";

/** Painel da Análise de Atendimento: rótulo curto (não é título de tela) + conteúdo. */
export default function Painel({ rotulo, acao, children, sx }) {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    return (
        <Card
            variant="outlined"
            sx={{
                p: 2,
                height: "100%",
                background: darkMode ? "#4B4F5C" : "#fafafa",
                borderColor: darkMode ? "#333" : "#ddd",
                ...sx,
            }}
        >
            {(rotulo || acao) && (
                <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1.5} gap={1} flexWrap="wrap">
                    {rotulo && (
                        <MDTypography variant="button" fontWeight="bold" color="text">
                            {rotulo}
                        </MDTypography>
                    )}
                    {acao}
                </MDBox>
            )}
            {children}
        </Card>
    );
}
